import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

const contacts = [
  {
    name: 'Nadine Gassner',
    competence: 'Office',
    shownPhone: '+43 (0) 699 174 074 03',
    phone: '004369917407403',
    email: 'office@holzweg.com',
    image: (
      <StaticImage
        src="../../../assets/Portrait_Nadine.jpeg"
        alt="Nadine Gassner"
      />
    ),
  },
  {
    name: 'Georg Bader',
    competence: 'Geschäftsführung',
    shownPhone: '+43 (0) 699 174 074 54',
    phone: '004369917407454',
    email: 'georg.bader@holzweg.com',
    image: (
      <StaticImage src="../../../assets/Georg.01.webp" alt="Georg Bader" />
    ),
  },
  {
    name: 'Clemens Huber',
    competence: 'Projektmanagement',
    shownPhone: '+43 (0) 699 174 074 56',
    phone: '004369917407456',
    email: 'clemens.huber@holzweg.com',
    image: (
      <StaticImage
        src="../../../assets/portraits/portrait_ch.webp"
        alt="Clemens Huber"
      />
    ),
  },
]

export default contacts
